"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var Componentinstagram = function Componentinstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    color: props.color
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    d: "M12 2.983c2.937 0 3.285.01 4.446.064 2.98.136 4.373 1.55 4.509 4.509.053 1.16.063 1.508.063 4.445 0 2.938-.01 3.285-.063 4.445-.137 2.956-1.525 4.373-4.51 4.509-1.16.053-1.506.064-4.445.064-2.937 0-3.285-.01-4.445-.064-2.988-.137-4.373-1.557-4.509-4.51-.053-1.16-.064-1.507-.064-4.445 0-2.937.012-3.284.064-4.445.137-2.958 1.525-4.373 4.51-4.509 1.16-.052 1.507-.063 4.444-.063ZM12 1c-2.987 0-3.361.013-4.535.066-3.995.183-6.215 2.4-6.398 6.398C1.013 8.64 1 9.013 1 12c0 2.987.013 3.362.066 4.536.183 3.994 2.4 6.215 6.398 6.398C8.64 22.987 9.013 23 12 23c2.987 0 3.362-.013 4.536-.066 3.99-.183 6.216-2.4 6.397-6.398.054-1.174.067-1.549.067-4.536 0-2.987-.013-3.361-.066-4.535-.18-3.99-2.399-6.215-6.397-6.398C15.362 1.013 14.987 1 12 1Zm0 5.351a5.649 5.649 0 1 0 0 11.298A5.649 5.649 0 0 0 12 6.35Zm0 9.316a3.666 3.666 0 1 1 0-7.333 3.666 3.666 0 0 1 0 7.333Zm5.872-10.858a1.32 1.32 0 1 0 0 2.64 1.32 1.32 0 0 0 0-2.64Z"
  }));
};
Componentinstagram.defaultProps = {
  color: "#FF7A00"
};
var _default = Componentinstagram;
exports["default"] = _default;